export type TaskStatus = 'todo' | 'doing' | 'done';
export const STATUS_ORDER: readonly TaskStatus[] = ['todo', 'doing', 'done'];
export const STATUS_LABEL: Record<TaskStatus, string> = { todo: 'Cần làm', doing: 'Đang làm', done: 'Hoàn thành' };
export const isTaskStatus = (v: unknown): v is TaskStatus => STATUS_ORDER.includes(v as TaskStatus);
